/**
 * Stable control ids for guest-auth FormErrorSummary links (must match FormField / checkbox ids).
 */
export const CUSTOMER_SIGN_IN_FIELD_IDS = {
  identifier: 'customer-sign-in-identifier',
  password: 'customer-sign-in-password',
  code: 'customer-sign-in-code',
  terms: 'customer-sign-in-consent-terms',
  privacy: 'customer-sign-in-consent-privacy',
} as const;

export const CUSTOMER_FORGOT_PASSWORD_FIELD_IDS = {
  identifier: 'customer-forgot-identifier',
} as const;

export const CUSTOMER_SET_CREDENTIALS_FIELD_IDS = {
  username: 'customer-onboarding-username',
  password: 'customer-onboarding-password',
  confirmPassword: 'customer-onboarding-confirm-password',
} as const;

export const CUSTOMER_REGISTER_FIELD_IDS = {
  organization: 'customer-register-organization',
  email: 'customer-register-email',
  phone: 'customer-register-phone',
  name: 'customer-register-name',
  terms: 'customer-register-consent-terms',
  privacy: 'customer-register-consent-privacy',
} as const;

export const CUSTOMER_RESET_PASSWORD_FIELD_IDS = {
  password: 'customer-reset-password',
  confirmPassword: 'customer-reset-confirm-password',
} as const;

export const CUSTOMER_SIGN_UP_PENDING_FIELD_IDS = {
  code: 'customer-sign-up-pending-code',
} as const;
